export const SELECT_DATA_POINT_LEVEL_NODE = {
  id: null,
  name: null,
  path: null,
};
